import Group from 'components/utils/Group'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  position: relative;
  grid-area: cta;
`

function AccommodationSameRoomOptionTileCTA(props: PropsWithChildren) {
  return <Container
    {...props}
    direction="vertical"
    gap={12}
  />
}

export default AccommodationSameRoomOptionTileCTA
